import { render, staticRenderFns } from "./VerticalSlotsMachine.vue?vue&type=template&id=f4802166&scoped=true&"
import script from "./VerticalSlotsMachine.vue?vue&type=script&lang=js&"
export * from "./VerticalSlotsMachine.vue?vue&type=script&lang=js&"
import style0 from "./VerticalSlotsMachine.vue?vue&type=style&index=0&id=f4802166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4802166",
  null
  
)

export default component.exports